import createTableStore from "ds/components/Table/store/useTableStore";

import {
  TEMPLATE_DEPLOYMENTS_COLUMN_CONFIG,
  TEMPLATE_DEPLOYMENTS_COLUMN_ID,
  TEMPLATE_DEPLOYMENTS_COLUMNS_STORAGE_KEY,
} from "./constants";

export const useTemplateDeploymentsTableStore = createTableStore({
  storageKey: TEMPLATE_DEPLOYMENTS_COLUMNS_STORAGE_KEY,
  config: TEMPLATE_DEPLOYMENTS_COLUMN_CONFIG,
});

const marketplaceColumnConfig = Object.fromEntries(
  Object.entries(TEMPLATE_DEPLOYMENTS_COLUMN_CONFIG).filter(
    ([key]) => key !== TEMPLATE_DEPLOYMENTS_COLUMN_ID.DEPLOYMENT_TYPE
  )
);

export const useTemplateDeploymentsMarketplaceTableStore = createTableStore({
  storageKey: `${TEMPLATE_DEPLOYMENTS_COLUMNS_STORAGE_KEY}_marketplace`,
  config: marketplaceColumnConfig,
});
